<template>
  <v-app>
    <div class="padding-card grey">
      <v-card class="padding-card">
        <v-row>
          <v-col>
            <p class="title-user-scr"> <v-icon> mdi-filter </v-icon>Filtros</p>
          </v-col>
          <v-col>
            <v-btn depressed @click="cleanFilter" color="primary" dark>Limpiar Filtro</v-btn>      
            <v-btn depressed @click="regresar" class="ml-3">Regresar</v-btn>     
          </v-col>          
        </v-row>
        <v-form ref="formFilters">
          <div>
            <v-row>   
                <v-col>
                  <DateSelect 
                      v-model="dates"                    
                      @change="updateFilterDates" 
                      :rules="rules.dateRange" />
                </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field 
                  dense  
                  :rules="rules.lenlg"
                  v-model="filter.concept"                   
                  label="Concepto"></v-text-field>
              </v-col>            
              <v-col>              
                <v-text-field 
                  dense 
                  :rules="rules.lenlg" 
                  v-model="filter.description"                
                  label="Descripción"></v-text-field>   
              </v-col>
              <v-col>              
                <v-text-field 
                  dense 
                  :rules="rules.lenlg" 
                  v-model="filter.supplier"                
                  label="Proveedor"></v-text-field>   
              </v-col>            
            </v-row>

            <v-row> 
              <v-col>       
                  <v-autocomplete
                      dense                 
                      v-model="filter.status"
                      :items="['Presupuesto', 'Programado', 'Procesado']"                
                      label="Status"
                    >
                  </v-autocomplete>    
                </v-col>    
                <v-col>       
                  <v-autocomplete
                      dense                 
                      v-model="filter.tipo_egreso"
                      :items="['Preventivo', 'Correctivo', 'Extraordinario', 'Equipamiento', 'Servicio']"                
                      label="Tipo de Egreso"
                    >
                  </v-autocomplete>    
                </v-col>    
                <v-col>
                  <v-autocomplete
                    dense               
                    v-model="filter.paymentTypeId"    
                    item-text="name"
                    item-value="id"
                    label="Tipo de pago"
                    :items="paymentItems"
                  ></v-autocomplete>
                </v-col>  
                <v-col>
                  <v-text-field 
                    dense 
                    :rules="rules.lenlg" 
                    v-model="filter.referencia"                
                    label="Referencia"></v-text-field> 
                </v-col>
              </v-row>            
            </div>
            <div style="margin:30px">
              <v-divider></v-divider>
            </div>
            <div style="margin-top: 1.5rem;">
              <v-row>
                <v-col>
                  <p class="title-user-scr"> <v-icon> mdi-list-box </v-icon>Campos a incluir</p>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="allFldsSwitch"
                    color="primary"
                    label="Todos"                              
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" v-for="(item, index) in fldList" :key="index">
                  <v-switch
                  v-model="fldToPrint"
                  color="primary"
                  :label="item.name"
                  :value="item.model"
                  hide-details
                  ></v-switch>
                </v-col>
              </v-row>           
            </div>          
          <v-card-actions style="margin-top: 1.5rem;">
            <v-btn depressed @click="printReport" color="#00aff2" dark>Vista Previa</v-btn>
            <v-spacer></v-spacer>          
          </v-card-actions>
        </v-form>
      </v-card>
    </div>  
  </v-app>
</template>

<script>
import adminSuppliersService from '@/services/admin/supplierPayments';
import DateSelect from '@/components/DateSelect2.vue';


export default {
  name: 'SpendReportForm',  
  components: {    
    DateSelect,
  },
  data() {    
    return {      
      filter:{
        concept: null,
        description: null,       
        supplier: null,
        referencia: null,
        status: null,
        paymentTypeId: null,
        tipo_egreso: null,  
        dates: null,   
      },   
      paymentItems: [],
      allFldsSwitch: true,
      allFlds: [ 'fecha_gasto','concept', 'description', 'supplier', 'referencia', 'status', 'paymentTypeId', 
      'tipo_egreso'],  
      fldToPrint:['fecha_gasto', 'concept', 'description', 'supplier', 'referencia', 'status', 'paymentTypeId', 
      'tipo_egreso'],
      fldList:[        
          {name:'Concepto', model:'concept'},
          {name: 'Descripción', model: 'description'},
          {name: 'Proveedor', model: 'supplier'},
          {name: 'Referencia', model: 'referencia'},
          {name: 'Status', model: 'status'},
          {name: 'Tipo de Pago', model:'paymentTypeId'},
          {name: 'Tipo Egreso',model:'tipo_egreso'}
        ],
      rules: {
          lenxl: [ (v) => !v || v.length <= 1024 || 'Nombre debe ser menor a 1024 caracteres' ],         
          lenlg: [ (v) => !v || v.length <= 255 || 'Nombre debe ser menor a 255 caracteres' ],  
          dateRange: [
              v => !v || v.length !== 2 || !v[0] || !v[1] || v[0] <= v[1] || 'La fecha inicial debe ser menor o igual que la fecha final',
            ]         
        },  
      dates: []
    }
  },
  mounted() {
    this.paymentTypes();
    this.allFldsSwitch = true;
    this.dates = [
      this.$dayjs().format('YYYY-MM-DD'),
      this.$dayjs().add(30, 'day').format('YYYY-MM-DD')
    ];
  },
  methods: {
    paymentTypes() {
      adminSuppliersService.paymentTypes().then((response) => {
        this.paymentItems = response.data;
      });
    }, 
    printReport() {     
      if(!this.$refs.formFilters.validate())  {
        console.log('forma invalida');
        return;  
      }   
       if (!this.fldToPrint.includes('amount')) 
                  this.fldToPrint.push('amount');
                
      let opts = this.filterNonNullValues(this.filter);       
      adminSuppliersService.getDataRep(opts, this.fldToPrint)
        .then((response) => {
          const dataRep = response.data;   
          if (dataRep.length > 0 ) {
            this.$router.push({
                  name: 'spendreport',
                  params: {                
                    dataRep: dataRep,
                    fields: this.fldToPrint
                  }
              });  
           } else {
            this.$swal('', 'No se encontrarón movimientos con ese criterio. Se recomienda "Limpiar Filtros".', 'warning');
           }     
        })
        .catch((err)=>{
          this.$swal('Error', err.response.data.message, 'warning');
        });
    },
    buildFilterOpt(opts) {
      const newObj = {};
      for (const [key, value] of Object.entries(opts)) {        
          newObj[key] = value;           
      }            
      return newObj;      
    },
   filterNonNullValues (obj) {
    return Object.fromEntries(
      Object.entries(obj).filter(([, value]) => {               
        return value !== null && value !== '';
      })
    );
  },
  cleanFilter() {
    this.filter = {
        concept: null,
        description: null,       
        supplier: null,
        referencia: null,
        status: null,
        dates:null,
        paymentTypeId: null,
        tipo_egreso: null,       
      };        
  },
  updateFilterDates(dates) {
    this.filter.dates = dates;
    this.dates = dates;
    console.log(dates);
  },
  regresar(){
    this.$router.push({ name: 'spend' });
  },
},
watch: {  
  'filter.concept' (newVal) {
    if (newVal != null && !this.fldToPrint.includes('concept')) {
      this.fldToPrint.push('concept');
    }
  },
  'filter.description' (newVal) {
    if (newVal != null && !this.fldToPrint.includes('description')) {
      this.fldToPrint.push('description');
    }
  },
  'filter.supplier' (newVal) {
    if (newVal != null && !this.fldToPrint.includes('supplier')) {
      this.fldToPrint.push('supplier');
    }
  },
  'filter.tipo_egreso' (newVal) {
    if (newVal != null && !this.fldToPrint.includes('tipo_egreso')) {
      this.fldToPrint.push('tipo_egreso');
    }
  },
  'filter.paymentTypeId' (newVal) {
    if (newVal != null && !this.fldToPrint.includes('paymentTypeId')) {
      this.fldToPrint.push('paymentTypeId');
    }
  },
  'filter.referencia' (newVal) {
    if (newVal != null && !this.fldToPrint.includes('referencia')) {
      this.fldToPrint.push('referencia');
    }
  },
  'filter.status' (newVal) {
    if (newVal != null && !this.fldToPrint.includes('status')) {
      this.fldToPrint.push('status');
    }
  },
  
  allFldsSwitch(newVal) {
    if (newVal) {
      this.fldToPrint = this.allFlds;
    } else if (!newVal) {
      this.fldToPrint = ['fecha_gasto'];
    }
  }
}}
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>